"use client";

import {
  useCallback,
  useState,
  type Dispatch,
  type SetStateAction,
} from "react";

export interface TimelineCollapsedSectionsState {
  collapsedSections: Set<number>;
  setCollapsedSections: Dispatch<SetStateAction<Set<number>>>;
}

export interface UseTimelineSectionToggleInput {
  clearTimelineTooltip: () => void;
  setCollapsedSections: Dispatch<SetStateAction<Set<number>>>;
}

export function useTimelineCollapsedSections(): TimelineCollapsedSectionsState {
  const [collapsedSections, setCollapsedSections] = useState<Set<number>>(
    new Set<number>(),
  );

  return {
    collapsedSections,
    setCollapsedSections,
  };
}

export function useTimelineSectionToggle({
  clearTimelineTooltip,
  setCollapsedSections,
}: UseTimelineSectionToggleInput): (sectionIndex: number) => void {
  return useCallback(
    (sectionIndex: number): void => {
      setCollapsedSections((previous) => {
        const next = new Set(previous);
        if (next.has(sectionIndex)) {
          next.delete(sectionIndex);
        } else {
          next.add(sectionIndex);
        }
        return next;
      });

      clearTimelineTooltip();
    },
    [clearTimelineTooltip, setCollapsedSections],
  );
}
